import Hero from "../../components/Hero";
import SkillsMarquee from "../../components/SkillsMarquee";
import ProjectsSection from "../../components/ProjectsSection";

function Home() {
  return (
    <>
      <Hero />
      <SkillsMarquee />
      <ProjectsSection />
    </>
  );
}

export default Home;